import Inputmask from "inputmask";

export default () => {

	const dateInputs = document.querySelectorAll('.js-date-mask');
	if (dateInputs.length) {
		dateInputs.forEach(input => {
			const dateMask = new Inputmask({
				alias: "datetime",
				inputFormat: "dd/mm/yyyy",
				min: "01/01/1870",
				max: "01/01/2020",
				showMaskOnHover: false
			});
			dateMask.mask(input);
		});
	}

}
